// A banner that drops from the top of the screen to say something happened:
// a text went out, an email went out, or why one did not. Call toast() from
// anywhere; <Toaster /> in App.js shows it.
//
// 6 Oct: Manny pressed "Text the link" on a rental three times because nothing
// on screen said it had sent, and received three texts. Every button outside
// Messages that sends a text or an email says so through this.

export function toast(message, kind = 'ok') {
  if (!message) return;
  window.dispatchEvent(new CustomEvent('spinboard-toast', { detail: { message, kind, id: Date.now() + Math.random() } }));
}

const fmtPhone = (p) => {
  const d = String(p || '').replace(/\D/g, '').slice(-10);
  return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : (p || '');
};
const first = (name) => (String(name || '').trim().split(/\s+/)[0] || 'the customer');

// Says what a change notice did, from a server `notified` result:
// { text: sent|failed|none|off, textNote, email: sent|failed|none, to: { phone, email } }.
// `what` names the change, e.g. "the new dates".
export function toastNotified(name, notified, what) {
  if (!notified) return;
  const who = first(name);
  const t = notified.text, e = notified.email;
  const sentBits = [];
  if (t === 'sent') sentBits.push(`texted ${who} at ${fmtPhone(notified.to && notified.to.phone)}`);
  if (e === 'sent') sentBits.push(`emailed ${notified.to && notified.to.email ? notified.to.email : who}`);
  if (sentBits.length) {
    const s = sentBits.join(' and ');
    toast(`${s.charAt(0).toUpperCase()}${s.slice(1)}${what ? ` with ${what}` : ''}.`, 'ok');
  }
  if (t === 'failed') toast(`The text to ${who} did not go out${notified.textNote ? `: ${notified.textNote}` : '.'}`, 'error');
  if (t === 'off') toast(`${who} was not texted: texting is not set up for the shop.`, 'warn');
  if (e === 'failed') toast(`The email to ${who} did not go out.`, 'error');
  if (t === 'none' && e === 'none') toast(`${who} has no phone or email on this booking, so nobody was told${what ? ` about ${what}` : ''}.`, 'warn');
}

export { fmtPhone as toastPhone };
